<ds-buy-checkoutdetails *ngIf="userType == 'current'"></ds-buy-checkoutdetails>
<ds-guest-buy-checkout *ngIf="userType == 'anonymous'"></ds-guest-buy-checkout>
